export default __webpack_public_path__ + "static/media/header.6f9734f1.jpg";